exports.fields = [
  { field: 'acbFinding_Type', column: 1 },
  { field: 'acbDate', column: 1 },
  { field: 'acbClass', column: 1 },
  { field: 'acbAuditor', column: 1 },
  { field: 'acbACB', column: 1 },
  { field: 'acbRemote', column: 1, mt: 4 },
  { field: 'acbLocation', column: 1 },
  { field: 'acbDepartment', column: 1 },
  { field: 'acbSystem', column: 1, mt: 4 },
  { field: 'acbTechnical', column: 1 },
  { field: 'acbFinding_Cat', column: 1 },
  { field: 'acbAudit', column: 2 },
  { field: 'acbObs', column: 2 },
  { field: 'acbOffNo', column: 2 },
  { field: 'acbFlag', column: 2 },
  { field: 'acbAuditType', column: 2, mt: 4 },
  { field: 'acbVCAType', column: 2 },
  { field: 'acbIQMSR', column: 2, mt: 4 },
  { field: 'acbRO_Code', column: 2 },
  { field: 'acbPR', column: 2 },
  { field: 'acbUR', column: 2 }
]
